import React, {useState} from 'react';
import DOMPurify from 'dompurify';
import {Button} from '@mui/material';
import {highlightPatterns} from '../../Common/Util';

interface ReadMoreProps {
  text: string;
  maxLength: number;
}

const TruncateSummary: React.FC<ReadMoreProps> = ({text, maxLength}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const renderContent = (content: string) => {
    return content.split('\n').map((item: string, idx: number) => (
      <span key={idx}>
        {item === '' ? (
          <br />
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(highlightPatterns(item)),
            }}
            className='mt3'
          />
        )}
      </span>
    ));
  };

  if (text.length <= maxLength) {
    return <div>{renderContent(text)}</div>;
  }

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  const textToShow = isExpanded ? text : text.substring(0, maxLength) + '...';

  return (
    <div>
      {renderContent(textToShow)}
      <Button
        onClick={toggleReadMore}
        size='small'
        sx={{textTransform: 'none', mt: 1}}
      >
        {isExpanded ? 'Read Less' : 'Read More'}
      </Button>
    </div>
  );
};

export default TruncateSummary;
